export const STEP_LANDING = 'landing';
export const STEP_CARD_NUMBER = 'card-number';
export const STEP_PHONE_NUMBER = 'phone-number';
export const STEP_SUCCESS = 'success';
